<template>
    <div class="flex flex-col items-center justify-center h-full">
        <div class="text-2xl font-bold">The resource you're looking for doesn't exist.</div>
        <div class="">Please check the URL and try again.</div>
    </div>
</template>
